import React, { Component } from 'react';

import { imgSrcAddPrefix } from '../utility/global'

export default class CategoryDataItem extends Component {
  render() {
    const {
      selectedCategoryIndex,
      setSelectedCategoryIndex,
      updateShowResultStatus,
      itemKey,
      categoryItem,
      // resetSelected
    } = this.props;
    // console.log(categoryItem)
    return (
      <div className="category__item"
        onClick={(e) => {
          setSelectedCategoryIndex(itemKey);
          // resetSelected(true);
          updateShowResultStatus(false);
        }}
      >
        <div className="category__box">
          {
            selectedCategoryIndex === itemKey ?
              <img
                className="category__img"
                src={imgSrcAddPrefix(categoryItem.categoryTypeActiveImage)}
                alt="" />
              :
              <img
                className="category__img"
                src={imgSrcAddPrefix(categoryItem.categoryTypeImage)}
                alt="" />
          }
        </div>
        <div className={`d-none d-lg-flex category__name ${selectedCategoryIndex === itemKey ? 'text-danger' : ''}`}>
          {categoryItem.categoryTypeName}
        </div>
      </div>
    )
  }
}
